import React, { useEffect, useState } from "react";
import { Form, Row, Spinner, Carousel } from "react-bootstrap";
import '../assets/css/CustomUtility.css'; // This is having invalid feedback and Datepicker related css
import '../assets/css/feather.css';
import '../assets/css/CG.css';
import '../assets/css/Login.css';
import SliderPayment from '../assets/images/Illustrations/Payment-mobile.svg';
import SliderWallet from '../assets/images/Illustrations/E-Wallet.svg';
import ServiceLinkLogo from '../assets/images/carriers-logo/servicelink-sso.png';
import DatePicker from "react-datepicker";
import { postApiService } from "../services/ApiService";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import 'react-toastify/dist/ReactToastify.css'; // import first
import { toast } from 'react-toastify'; // then this
import { SetPayLoad } from "../services/PayLoadStorage";
import { getMonth, getYear } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { getApiService } from "../services/ApiService";
import { getCookieOptions } from '../utils/cookieUtils';
import { setLoginFromFlag, setConnectiCareCarrier } from "../utils/findLoginSource";
import { is } from "date-fns/locale";

const Login = () => {

    const [selectedDoB, setSelectedDoB] = useState("");
    const [siteCd, setSiteCd] = useState("");
    const [formErrors, setFormErrors] = useState([]);
    const [region, setRegion] = useState();
    const [isLoading, setIsLoading] = useState();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();
    const [userID, setuserID] = useState(null);
    const [selectedCarrierName, setSelectedCarrierName] = useState();

    // Carrier code to URL name mapping
    const getCarrierUrlName = (carrierCode) => {
        const CARRIER_CODE_TO_NAME = {
            'CG': 'cigna',
            'J1': 'cigna',
            'XC': 'christus',
            'X6': 'hcsc',
            'Q5': 'bcbsaz',
            'M1': 'mhc',
            'SY': 'sentara',
            'C4': 'molina',
            'C4CT': 'connecticare', // ConnectiCare special case
        };
        return CARRIER_CODE_TO_NAME[carrierCode?.toUpperCase()] || '';
    };

    //Check if region is exists
    useEffect(() => {
        const region = Cookies.get('region');
        const appEnv = process.env.REACT_APP_ENVIRONMENT;
        if (!region && appEnv !== 'PROD') {
            toast.info('Please select a region to proceed.');
            navigate('/SlpMember');
        }

    }, []); 

    const { setAuthData } = useAuth();

    const [ssoForm, setSSOForm] = useState({
        memberid: '',
        ssn: '',
        zip: ''
    });

    const baseUrl = process.env.REACT_APP_API_BASE_URL;

    const [arrCarrier, setArrCarrier] = useState([]);  
    // Fetch login dropdown from API on component mount
        useEffect(() => {
            const headers = {
                "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
                "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
            };
            const targetUrl = process.env.REACT_APP_API_GET_ALLOWED_MEMBER_LOGIN_ENDPOINT;
            getApiService(baseUrl, targetUrl, {}, headers)
                .then((response) => {
                    if (response?.data && response?.data?.status === 'SUCCESS') {
                        const result = response.data.data;
                        setArrCarrier(result);
                    }
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        }, [baseUrl]);

    const handleChange = (e) => {

        const { name, value } = e.target;
        setSSOForm({ ...ssoForm, [name]: value });
        //clear the relevant error when the user starts typing
        if (name === 'memberid' && value.trim() !== '') {
            setFormErrors(prevErrors => ({ ...prevErrors, memberid: '' }));
            setFormErrors(prevErrors => ({ ...prevErrors, ssn: '' }));
        }
        if (name === 'ssn' && value.trim() !== '') {
            setFormErrors(prevErrors => ({ ...prevErrors, memberid: '' }));
            setFormErrors(prevErrors => ({ ...prevErrors, ssn: '' }));
        }
        if (name === 'zip' && value.trim() !== '') {
            setFormErrors(prevErrors => ({ ...prevErrors, zip: '' }));
        }
    }
    //Focus text box
    const handleBlur = (e) => {
        handleChange(e);
    }

    const validation = () => {

        let isValid = true;
        const errors = {};

        if ((!ssoForm?.memberid || ssoForm?.memberid.trim() === '') &&
            (!ssoForm?.ssn || ssoForm?.ssn.trim() === '')) {
            if(siteCd === 'cg'){
                errors.memberid = "Please provide either Member ID or SSN to proceed";
                errors.ssn = "Please provide either Member ID or SSN to proceed";
            }else{
                errors.memberid = "Please provide Member ID to proceed";
            }
            isValid = false;
        } else if (ssoForm?.ssn !== '' && !/^\d*$/.test(ssoForm?.ssn)) {
            errors.ssn = "Invalid SSN, Only numeric values are allowed.";
            isValid = false;
        } else {
            delete errors.ssn;
        }

        if (ssoForm?.zip === "" && siteCd !== 'cg') {
            errors.zip = "Enter the Zip Code";
            isValid = false;
        } else if (ssoForm?.zip !== '' && !/^\d*$/.test(ssoForm?.zip)) {
            errors.zip = "Invalid Zip Code, Only numeric values are allowed.";
            isValid = false;
        } else {
            delete errors.zip;
        }
        //DOB Validation
        if (selectedDoB === "" || selectedDoB === null) {
            errors.dob = "Enter the Date Of Birth, Format is: MM/DD/YYYY";
            isValid = false;
        } else {
            delete errors.dob;
        }

        setIsSubmitting(false);
        setFormErrors(errors);
        return isValid;
    }

    const handleDateChange = (date) => {
        setSelectedDoB(date);
        // Optionally clear the error when the user starts selecting a date
        setFormErrors(prevErrors => ({ ...prevErrors, dob: '' }));
    };

    //Set if carrier array is one value; Set dynamic sitcd value
    useEffect(() => {
        if (!selectedCarrierName) {
            setSiteCd(arrCarrier[0]?.id);
            setSelectedCarrierName(arrCarrier[0]?.name);
            Cookies.set('carrierName', btoa(arrCarrier[0]?.name), getCookieOptions());
        }
    }, [arrCarrier]);

    const handleSSOSliderChange = (e) => {
        let carrier_id = e.target.value;
        let carrier_name = e.target.options[e.target.selectedIndex].text;
        setSiteCd(carrier_id);
        setSelectedCarrierName(carrier_name);
        Cookies.set('carrierName', Cookies.get('isConnectiCareCarrier') === 'true' ? 'Connecticare member portal' : btoa(carrier_name), getCookieOptions());
        //setFormErrors(prevErrors => ({ ...prevErrors, memberid: '', ssn: '', dob: '', zip: '' })); // Clear errors when carrier changes
        //setSSOForm({ memberid: '', ssn: '', zip: '' }); // Clear form fields when carrier changes
        //setSelectedDoB(''); // Clear DOB when carrier changes
    }

    useEffect(() => {
        if (Cookies.get('region')) {
            setRegion(Cookies.get('region'));
        }
    }, []);

    //Format date to MM/DD/YYYY
    const formatDate = (date) => {
        if (!date) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, "0");
        return month + '/' + day + '/' + year;
    };
    //Get user ID from cookies
    useEffect(() => {
        if (!!Cookies.get('authID')) {
            const datakey = Cookies.get('authID');
            const loggedId = datakey ? JSON.parse(atob(datakey)) : null;
            setuserID(loggedId?.loggedId);
        }
    }, []);

    const handleMultipleIlbLogin = (result) => {
       
        if(result?.multipleIlb !== undefined){
            const multipleIlb = result?.multipleIlb;
            const activeCases = multipleIlb?.activeCases || [];
            //set carrier code and state code to identify ConnectiCare carrier with active cases for multiple ILB scenario
            let carrierCode = result?.[0]?.owning_carrier?.toUpperCase() || null;
            let stateCode = result?.[0]?.state || null;  
            let cim = result?.[0]?.cim || null; // Assuming CIM is also needed based on previous code context          
            let resultValue = carrierCode+stateCode;
            let isConnectiCareCarrier = false;
            let connectiCareCarrier = null;
            if(activeCases !== ''){
                //Set the active cases to session storage
                SetPayLoad('ActiveCases', btoa(JSON.stringify(activeCases)));
                localStorage.setItem('multipleILB', 'true');        
                
                if(resultValue === process.env.REACT_APP_CONNECTICARE_CARRIER_CODE){
                    isConnectiCareCarrier = true;
                    connectiCareCarrier = process.env.REACT_APP_CONNECTICARE_CARRIER_CODE;
                }
                Cookies.set('isConnectiCareCarrier', isConnectiCareCarrier, getCookieOptions());
                sessionStorage.setItem('stateCode', stateCode); // Set state code in session storage for ConnectiCare carriers
                sessionStorage.setItem('cimNumber', cim); // Set CIM in session storage for ConnectiCare carriers
                if(isConnectiCareCarrier){
                    Cookies.set('connectiCareCarrier', connectiCareCarrier, getCookieOptions());
                }
                //set carrier code and state code to identify ConnectiCare carrier with active cases for multiple ILB scenario
            }
        }
    }

    //Set Login From Flag API Call
    const createLoginFromSource = () => {
        // Create unique string value from available fields
        const stringValue = [
            ssoForm?.memberid || null,
            ssoForm?.ssn || null,
            selectedDoB ? formatDate(selectedDoB) : null,
            ssoForm?.zip || null,
            siteCd || null,
            userID || null
        ].filter(val => val !== null && val !== '' && val !== undefined).join('|') || null;

        setLoginFromFlag(stringValue);
    }

    const handleSubmit = (ele) => {

        ele.preventDefault();

        if (validation()) {

            //If SSO process is enabled, then call SSO API
            const ssoPrcess = process.env.REACT_APP_API_SSO_PROCESS;
            setIsSubmitting(true); // Disable the button immediately
            setIsLoading(true);
            setTimeout(async () => {
                const payload = new FormData();
                const baseUrl = process.env.REACT_APP_API_BASE_URL;
                const headers = {
                    "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
                    "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
                };
                payload.append("memberid", ssoForm?.memberid);
                payload.append("ssn", ssoForm?.ssn);
                payload.append("dob", formatDate(selectedDoB));
                payload.append("zip", ssoForm?.zip);
                payload.append("carrier", siteCd.toUpperCase());
                payload.append("site_cd", siteCd.toUpperCase() + 'MBR');
                payload.append("region", region);
                payload.append("userid", userID);
                Cookies.set('owningCarrier', siteCd.toUpperCase(), getCookieOptions());

                if(Cookies.get('portal_lang') !== '' && Cookies.get('portal_lang') !== undefined){
                    Cookies.set('lang', Cookies.get('portal_lang'), getCookieOptions());
                }else {
                    Cookies.set('lang', 'eng', getCookieOptions());
                }

                if (ssoPrcess === 'TRUE') {
                    const targetLoginUrl = process.env.REACT_APP_API_SSO_SIMULATION_ENDPOINT;
                    const response = await fetch(baseUrl + targetLoginUrl, {
                        method: 'POST',
                        headers: headers,
                        body: payload
                    });
                    //Api response will be HTML form
                    const html = await response.text();
                    const container = document.createElement('div');
                    container.innerHTML = html;
                    const form = container.querySelector('form');
                    if (form) {
                        sessionStorage.setItem('loginFrom', 'Internal'); // Set loginFrom in session storage for SSO simulation
                        setIsLoading(false);
                        document.body.appendChild(form); // Append the form to the body
                        form.submit(); // Submit the form
                    } else {
                        setIsLoading(false);
                        setIsSubmitting(false);
                        handleLoginErr('Something went wrong. Please try again later.');
                    }
                } else {
                    
                    const targetLoginUrl = process.env.REACT_APP_API_LOGIN_ENDPOINT;
                    postApiService(
                        baseUrl,
                        targetLoginUrl,
                        payload,
                        headers
                    ).then((result) => {
                        if (result?.data?.statusCode === 200) {
                            const response = result.data.data;
                            if (response?.LoginStatus === true) {
                                const res = JSON.parse(atob(response?.MemberPayload));
                                if(res?.multipleIlb !== undefined){
                                   handleMultipleIlbLogin(res);
                                }
                                setAuthData(response?.MemberPayload);
                                const IsMultipleIlb = localStorage.getItem('multipleILB') || 'false';

                                if(IsMultipleIlb !== 'true'){
                                    SetPayLoad('PayLoad', response?.MemberPayload);
                                    setConnectiCareCarrier(); // Set ConnectiCare carrier flag in cookies
                                }    
                                const defaultLang = res?.defaultLang;                                    
                                if(defaultLang !== '' && defaultLang === 'SPANISH'){
                                    Cookies.set('lang', 'spa', getCookieOptions());
                                }
                                setIsLoading(false);
                                sessionStorage.setItem('loginFrom', 'Internal'); // Set loginFrom in session storage for non-SSO login
                                
                                // Get carrier URL name from owning_carrier code and redirect
                                // Use window.location to properly set the carrier basename
                                // For ConnectiCare, check connectiCareCarrier cookie
                                const connectiCareCarrier = Cookies.get('connectiCareCarrier');
                                const carrierCode = connectiCareCarrier ? connectiCareCarrier : IsMultipleIlb === 'true' ? res?.[0]?.owning_carrier : res?.owning_carrier;
                                const carrierUrlName = getCarrierUrlName(carrierCode);

                                // Redirect based on whether the member has multiple ILB or not
                                if(IsMultipleIlb === 'true'){
                                    window.location.href = `/${carrierUrlName}/landing`;
                                }else{
                                    window.location.href = `/${carrierUrlName}/overview`;
                                }
                                
                            } else {
                                setIsLoading(false);
                                setIsSubmitting(false);
                                handleLoginErr(response?.Message);

                            }
                        }
                    }).catch(error => {
                        console.error('Error fetching data:', error);
                    });
                }
            }, 1000); //Set delay 2 seconds for api call        
        }
    }


    //Login Error
    const notify = (errMsg) => toast.error(errMsg);
    const handleLoginErr = (errMsg) => {
        notify(errMsg); // Call the notify function here
    };

    //Custom Header DatePicker
    const years = Array.from({ length: getYear(new Date()) - 1900 + 1 }, (_, i) => 1900 + i);
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];


    return (
        <>
            <section className="min-h-screen d-flex justify-content-center"
                style={{
                    height: '100vh',
                    margin: 0,
                    padding: 0,
                    overflow: 'auto'
                }}
            >
                <div className="container-fluid h-100"
                    style={{
                        margin: 0,
                        padding: 0
                    }}
                >
                    <div className="row justify-content-center h-100"
                        style={{
                            margin: 0
                        }}
                    >
                        <div className="col-12 col-xxl-11 px-0 h-100">
                            <div
                                style={{
                                    background: '#fff'
                                }}
                                className="border-light-subtle mb-0 login-card-wrapper"
                            >
                                <div className="row g-0 shadow-lg h-100">
                                    <div className="col-12 col-md-6 overlay-sl text-end pt-xl-3 p-3 p-sm-0 p-md-0 p-xl-0">
                                        
                                        <Carousel
                                            interval={5000}
                                            controls={false}
                                            indicators={true}
                                            prevIcon={null}
                                            nextIcon={null}
                                            className="slide login-carousel"
                                        >
                                            <Carousel.Item className="carousel-item" tabIndex={0}>
                                                <div className="carousel-caption d-md-block px-md-5 pb-md-5 slider-size">
                                                    <img src={SliderPayment} alt="Payment-mobile" className="mw-84" />
                                                </div>
                                            </Carousel.Item>
                                            <Carousel.Item className="carousel-item" tabIndex={0}>
                                                <div className="carousel-caption d-md-block px-md-5 pb-md-5 slider-size">
                                                    <img src={SliderWallet} alt="E-Wallet" className="mw-90" />
                                                </div>
                                            </Carousel.Item>
                                        </Carousel>
                                    </div>
                                    <div className="col-12 col-md-6 d-flex mt-4 justify-content-center">
                                        <div className="col-12 col-lg-11 col-xl-10">
                                            <div className="card-body p-3 p-md-4 p-xl-3">
                                                <div className="row">
                                                    <div className="col-12 d-flex flex-column flex-sm-row">
                                                        <div tabIndex={0} className="col-12 col-sm-6">
                                                            <img src={ServiceLinkLogo} className="mb-2" width="200" alt="servicelogo" />
                                                        </div>
                                                        <div tabIndex={0} className="col-12 col-sm-6 text-sm-end">
                                                            <h2 style={{ fontSize: '16.5px' }} className="text-left fw-semibold primary-color">SSO Simulation</h2>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row gy-3 overflow-hidden mt-0">
                                                    <Form>
                                                        <div className="col-12">
                                                            <div className="mb-1">
                                                                <Row>
                                                                    <Form.Group>
                                                                        <Form.Label
                                                                            className="form-label"
                                                                            for="selectcarrier"
                                                                            tabIndex={0}>
                                                                            Select Carrier
                                                                        </Form.Label>
                                                                        <Form.Select
                                                                            className="form-login-select form-login-control"
                                                                            name="carrier"
                                                                            onChange={handleSSOSliderChange}
                                                                            value={siteCd}
                                                                            selected={siteCd}
                                                                        >
                                                                            {
                                                                                arrCarrier && arrCarrier.map((item, key) =>
                                                                                    <option value={item.id}>{item.name}</option>
                                                                                )
                                                                            }
                                                                        </Form.Select>
                                                                    </Form.Group>
                                                                </Row>
                                                            </div>
                                                        </div>
                                                    </Form>
                                                    <div className="member-SLP">
                                                        <h3 tabIndex={0} style={{ fontSize: '1rem' }} className="border-bottom text-left fw-semibold primary-color mb-3 pb-2">
                                                            {selectedCarrierName}
                                                        </h3>
                                                        <Form name="cg-slider">
                                                            <Row>
                                                                <div className="col-12 d-flex flex-wrap">
                                                                    <div className="col-12 col-sm-6 position-relative mb-3 formicon pe-sm-3">
                                                                        <Form.Group>
                                                                            <Form.Label
                                                                                className="form-label"
                                                                                for="MemberId">
                                                                                {siteCd === 'c4' ? ( 'MRN(Member Id)' ) : ( 'Member Id' )}
                                                                                {siteCd !== 'cg' && ( <span className="text-danger">*</span> )}
                                                                            </Form.Label>
                                                                            <Form.Control
                                                                                className="form-login-control"
                                                                                inputMode="numeric"
                                                                                type="text"
                                                                                name="memberid"
                                                                                id="memberid"
                                                                                pattern="[0-9]*"
                                                                                placeholder="Member Id"
                                                                                autoComplete="off"
                                                                                isInvalid={!!formErrors.memberid}
                                                                                onChange={(e) => { handleChange(e) }}
                                                                                onBlur={(e) => { handleBlur(e) }}
                                                                                aria-label="MemberId"
                                                                                value={ssoForm?.memberid}
                                                                            >
                                                                            </Form.Control>
                                                                            <i className="fe fe-users fe-18 asset position-absolute me-3 login-memberid-icon"
                                                                                style={{ pointerEvents: 'none' }}
                                                                            ></i>
                                                                            <Form.Control.Feedback type="invalid" style={{ fontSize: '0.65em' }}>
                                                                                {formErrors.memberid}
                                                                            </Form.Control.Feedback>
                                                                        </Form.Group>
                                                                    </div>
                                                                    {siteCd === 'cg' && (
                                                                    <div className="col-12 col-sm-6 position-relative mb-3 formicon pe-0">
                                                                        <Form.Group>
                                                                            <Form.Label
                                                                                className="form-label"
                                                                                for="MemberId">
                                                                                SSN
                                                                            </Form.Label>
                                                                            <Form.Control
                                                                                className="form-login-control"
                                                                                inputMode="numeric"
                                                                                type="text"
                                                                                name="ssn"
                                                                                placeholder="SSN"
                                                                                autoComplete="off"
                                                                                pattern="[0-9]*"
                                                                                isInvalid={!!formErrors.ssn}
                                                                                onChange={(e) => { handleChange(e) }}
                                                                                onBlur={(e) => { handleBlur(e) }}
                                                                                aria-label="SSN"
                                                                                value={ssoForm?.ssn}
                                                                            >
                                                                            </Form.Control>
                                                                            <Form.Control.Feedback type="invalid" style={{ fontSize: '0.65em' }}>
                                                                                {formErrors.ssn}
                                                                            </Form.Control.Feedback>
                                                                        </Form.Group>
                                                                    </div>
                                                                    )}
                                                                </div>
                                                            </Row>
                                                            <Row>
                                                                <div className="col-12 d-flex flex-wrap">
                                                                    <div className="col-12 col-sm-6 position-relative mb-3 formicon pe-sm-3">
                                                                        <Form.Group>
                                                                            <Form.Label
                                                                                for="dob" className="form-label">
                                                                                Date of Birth
                                                                                <span className="text-danger">*</span>
                                                                            </Form.Label>

                                                                            <div className="datepicker-container">
                                                                                <label id="dob-label" style={{ display: 'none' }}>Date of Birth</label> {/* st48236 - 508 compliance Hidden label for accessibility */}
                                                                                <DatePicker
                                                                                    className={`form-login-control datepicker ${formErrors.dob ? 'is-invalid' : ''}`}
                                                                                    autoComplete="off"
                                                                                    ariaLabelledBy="dob-label" // Links the label to the DatePicker //st48236 - 508 compliance
                                                                                    ariaRequired="true" // Indicates the field is required //st48236 - 508 compliance
                                                                                    placeholderText="MM/DD/YY"
                                                                                    popperProps={{
                                                                                        strategy: "fixed", // use this to make the popper position: fixed
                                                                                    }}
                                                                                    popperPlacement="bottom-start"
                                                                                    dateFormat="MM/dd/yyyy"
                                                                                    value={selectedDoB}
                                                                                    selected={selectedDoB}
                                                                                    onChange={handleDateChange}
                                                                                    isInvalid={!!formErrors.dob}
                                                                                    renderCustomHeader={({
                                                                                        date,
                                                                                        changeYear,
                                                                                        changeMonth,
                                                                                        decreaseMonth,
                                                                                        increaseMonth,
                                                                                        prevMonthButtonDisabled,
                                                                                        nextMonthButtonDisabled,
                                                                                    }) => (
                                                                                        <div className="datepicker-custom-header">
                                                                                            <button
                                                                                                className="month-btn"
                                                                                                onClick={decreaseMonth}
                                                                                                disabled={prevMonthButtonDisabled}
                                                                                                type="button"
                                                                                            >
                                                                                                {"<"}
                                                                                            </button>

                                                                                            {/* Year Selection */}
                                                                                            <select
                                                                                                className="year-select"
                                                                                                value={getYear(date)}
                                                                                                onChange={({ target: { value } }) => changeYear(parseInt(value))} // Convert to number
                                                                                            >
                                                                                                {years.map((year) => (
                                                                                                    <option key={year} value={year}>
                                                                                                        {year}
                                                                                                    </option>
                                                                                                ))}
                                                                                            </select>

                                                                                            {/* Month Selection */}
                                                                                            <select
                                                                                                className="month-select"
                                                                                                value={months[getMonth(date)]}
                                                                                                onChange={({ target: { value } }) =>
                                                                                                    changeMonth(months.indexOf(value)) // Get the index of the selected month
                                                                                                }
                                                                                            >
                                                                                                {months.map((month, index) => (
                                                                                                    <option key={month} value={month}>
                                                                                                        {month}
                                                                                                    </option>
                                                                                                ))}
                                                                                            </select>
                                                                                            <button
                                                                                                className="month-btn"
                                                                                                onClick={increaseMonth}
                                                                                                disabled={nextMonthButtonDisabled}
                                                                                                type="button"
                                                                                            >
                                                                                                {">"}
                                                                                            </button>
                                                                                        </div>
                                                                                    )}
                                                                                />
                                                                                <i className="fe fe-calendar fe-18 asset position-absolute me-3 login-calander-icon navy-icon"></i>
                                                                            </div>
                                                                            {formErrors.dob && (<div className="invalid-feedback" style={{ display: 'block', fontSize: '0.65em' }}>{formErrors.dob}</div>)}
                                                                        </Form.Group>
                                                                    </div>
                                                                    {siteCd !== 'cg' && (
                                                                    <div className="col-12 col-sm-6 position-relative mb-3 formicon pe-0">
                                                                        <Form.Group>
                                                                            <Form.Label
                                                                                for="Zipcode"
                                                                                className="form-label"
                                                                            >
                                                                                Zip Code
                                                                                <span className="text-danger">*</span>
                                                                            </Form.Label>
                                                                            <Form.Control
                                                                                className="form-login-control"
                                                                                inputMode="numeric"
                                                                                pattern="[0-9]*"
                                                                                isInvalid={!!formErrors.zip}
                                                                                placeholder="Zip Code"
                                                                                autoComplete="off"
                                                                                onChange={(e) => { handleChange(e) }}
                                                                                onBlur={(e) => { handleBlur(e) }}
                                                                                id="zip"
                                                                                name="zip"
                                                                                aria-label="Zipcode"
                                                                                type="text"
                                                                                value={ssoForm?.zip}
                                                                            >
                                                                            </Form.Control><i className="fe fe-map-pin fe-18 position-absolute asset login-zipcode-icon"></i>
                                                                            <Form.Control.Feedback type="invalid" style={{ fontSize: '0.65em' }}>
                                                                                {formErrors.zip}
                                                                            </Form.Control.Feedback>
                                                                        </Form.Group>
                                                                    </div>
                                                                    )}
                                                                </div>
                                                            </Row>
                                                            <div className="col-12 mb-4 mt-3">
                                                                <div className="d-grid">
                                                                    {isLoading && (
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit', paddingBottom: '10px' }}>
                                                                            <Spinner animation="border" role="status" ></Spinner>
                                                                            <div style={{ fontSize: "15px" }}>Please wait while logging in...</div>
                                                                        </div>
                                                                    )}
                                                                    <button onClick={handleSubmit}
                                                                        disabled={isSubmitting}
                                                                        style={{ display: isSubmitting ? 'none' : 'block', fontSize: '1rem' }}
                                                                        value="Sign In" className="d-grid btn btn-dark btn-lg button">
                                                                        Sign In
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </Form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
};

export default Login;